<template>
	<div class="sp-template">
		<div class="h-title">供应商管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
					<el-form-item>
						<el-input v-model="conditions.clientName" placeholder="请输入供应商名称" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button v-if="in_configs(70204)" type="primary" @click="supplierSearch">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(70201)" size="small" @click="addSupplier">添加供应商</el-button>
        </div>
      </div>
			<el-table ref="multipleTable" v-loading="loading" :data="supplierData" stripe border style="width: 100%">
				<el-table-column prop="clientName" label="供应商"></el-table-column>
				<el-table-column prop="contactWay" label="联系方式"></el-table-column>
				<el-table-column prop="companyEmail" label="公司邮箱"></el-table-column>
				<el-table-column prop="companyAddress" label="公司地址"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="formatStatus"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope" >
						<el-button type="text" size="mini" v-if="in_configs(70202)" @click="supplierEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="mini" v-if="in_configs(70203)" @click="supplierDelete(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="supplierSizeChange" @current-change="supplierCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<el-dialog title="供应商信息" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('supplierForm')" class="fullwidth-form__dialog" width="500px">
				<el-form :model="supplierForm" status-icon :rules="rules" ref="supplierForm" size="small" label-width="80px">
          <el-form-item label="供应商"  prop = "clientName">
						<el-input v-model="supplierForm.clientName" auto-complete="off" placeholder="供应商名称"></el-input>
					</el-form-item>
					<el-form-item label="联系方式"  prop = "contactWay">
						<el-input v-model="supplierForm.contactWay" auto-complete="off" placeholder="联系方式"></el-input>
					</el-form-item>
					<el-form-item label="联系邮箱"  prop = "companyEmail">
						<el-input v-model="supplierForm.companyEmail" auto-complete="off" placeholder="联系邮箱"></el-input>
					</el-form-item>
					<el-form-item label="公司地址"  prop = "companyAddress">
						<el-input v-model="supplierForm.companyAddress" auto-complete="off" placeholder="公司地址"></el-input>
					</el-form-item>
					<el-form-item label="状态" >
						<el-radio v-model="supplierForm.status" label="1">启用</el-radio>
						<el-radio v-model="supplierForm.status" label="0">停用</el-radio>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="close('supplierForm')">取 消</el-button>
					<el-button size="small" type="primary" @click="submitSupplierForm('supplierForm')">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
export default {
  data() {
    //验证供应商名称
    var validateClientName = (rule, value, callback) => {
      if (this.flag) {
        if (value == this.supplierData.clientName) {
          callback();
          return;
        }
      }
      this.$request1({
        method: 'GET',
        url: '/supplier/unique',
        params: { clientName: this.supplierForm.clientName }
      })
        .then(response => {
          if (response.data.message == "exist") {
            callback(new Error("供应商已存在"));
          } else {
            callback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    return {
      conditions: {
        clientName: ""
      },
      supplierData: [],
      supplierForm: {
        id: "",
        clientName: "",
        contactWay: "",
        companyEmail: "",
        companyAddress: "",
        status: "1"
      },
      rules: {
        clientName: [
          { required: true, message: "请输入供应商名称", trigger: "blur" },
          { validator: validateClientName, trigger: "blur" }
        ],
        contactWay: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
        ],
        companyEmail: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur"
          }
        ],
        companyAddress: [
          { required: true, message: "请输入公司地址", trigger: "blur" }
        ]
      },
      currentPage: 1, //当前页
      total: 1, //总条数
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      dialogFormVisible: false,
      flag: false,
      loading: true,
      status: 0
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.loading = false;
      this.loadSupplier();
    }, 1000);
  },
  computed: {},
  methods: {
    //加载数据
    loadSupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier/load',
        params: {
          clientName: this.conditions.clientName,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          this.supplierData = response.data.data;
          this.total = response.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //转换状态显示：1：启用 0：停用
    formatStatus(data) {
      return data.status == "1" ? "启用" : "停用";
    },
    //搜索
    supplierSearch() {
      this.currentPage = 1;
      this.loadSupplier();
    },
    //编辑
    supplierEdit(index, row) {
      this.flag = true;
      this.dialogFormVisible = true;
      this.supplierForm.id = row.supplierId;
      this.supplierForm.clientName = row.clientName;
      this.supplierData.clientName = row.clientName;
      this.supplierForm.contactWay = row.contactWay;
      this.supplierForm.companyEmail = row.companyEmail;
      this.supplierForm.companyAddress = row.companyAddress;
      this.supplierForm.status = row.status.toString();
      this.status = 1;
    },
    addSupplier() {
      this.dialogFormVisible = true;
      this.flag = false;
      this.status = 0;
    },
    //添加/修改供应商
    submitSupplierForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'post',
            url: '/supplier/save',
            data: this.supplierForm
          })
            .then(response => {
              this.dialogFormVisible = false;
              this.$refs[formName].resetFields();
              this.emptyForm();
              this.loadSupplier();
              this.success();
            })
            .catch(error => {
              this.$message.error("操作失败");
            });
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除
    supplierDelete(index, row) {
      let self = this;
      this.$confirm("此操作将永久删除该供应商, 是否继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(_ => {
          this.$request1({
            method: 'post',
            url: '/supplier/delete',
            params: {
              supplierId: row.supplierId
            }
          })
            .then(response => {
              self.supplierData.splice(index, 1);
              this.$message({
                message: "删除成功",
                type: "success",
                center: true,
                duration: 1500
              });
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(_ => {});
    },
    //清空表单数据
    emptyForm() {
      this.dialogFormVisible = false;
      this.supplierForm.id = "";
      this.supplierForm.clientName = "";
      this.supplierForm.contactWay = "";
      this.supplierForm.companyEmail = "";
      this.supplierForm.companyAddress = "";
      this.supplierForm.status = "1";
    },
    //清除验证
    close(formRule) {
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    //操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    //分页
    supplierSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.loadSupplier();
    },
    supplierCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.loadSupplier();
    }
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/supplier.vue